import React, { useState } from "react";
import styles from "styles.module.css";
import { addWeeks } from "date-fns";
import { useTranslation } from "react-i18next";
import { PurchaseStatisticFilter } from "api/purchaseStatistic";
import { useUserStore } from "store";
import { UserRole } from "interface/user";
import CustomStepper from "ui/CustomStepper";
import PurchaseStatisticsDetails from "./PurchaseStatisticsDetails";
import PurchaseStatisticTotal from "./PurchaseStatisticsTotal";

const pageSize = 60;

enum Tabs {
	PurchaseStatisticDetails = "Details",
	PurchaseStatisticTotal = "Total",
}

const tabs = [Tabs.PurchaseStatisticDetails, Tabs.PurchaseStatisticTotal];

const PurchaseStatisticPage = () => {
	const { t } = useTranslation();
	const { roles } = useUserStore();
	const [tab, setTab] = React.useState(Tabs.PurchaseStatisticDetails);
	const [step, setStep] = React.useState(0);

	const getDefaultFromDate = () => {
		const date = roles.includes(UserRole.Admin)
			? addWeeks(new Date(), -1)
			: addWeeks(new Date(), -1);
		date.setHours(0, 0, 0, 0);
		return date;
	};

	const getDefaultToDate = () => {
		const date = new Date();
		date.setHours(23, 59, 59, 0);
		return date;
	};

	const [filterOptions, setFilterOptions] = useState<PurchaseStatisticFilter>({
		take: pageSize,
		skip: 0,
		fromDate: getDefaultFromDate(),
		toDate: getDefaultToDate(),
	});

	const handleStepTabs = (index: number) => {
		if (index === 0) {
			setTab(Tabs.PurchaseStatisticDetails);
		} else if (index === 1) {
			setTab(Tabs.PurchaseStatisticTotal);
		}
		setStep(index);
	};

	return (
		<div className={styles.PageContainer}>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>
					{t("PurchaseStatistic") + " -  " + t(tab)}
				</legend>
			</div>
			<CustomStepper
				className="user-information-stepper"
				steps={tabs.map((tab) => ({
					label: t(tab),
					optional: false,
				}))}
				activeStep={step}
				setActiveStep={handleStepTabs}
			/>

			{/* <div style={{ marginTop: 30 }}>
				{isMobileView ? (
					<PurchaseStatisticMobileList
						items={mobileData}
						loading={mobileLoading}
					/>
				) : (
					<GridWithGroupPaging
						dataKey=""
						gridColumns={PurchaseStatisticColumnItem(gridData)}
						filter={filterOptions}
						exportGridAsPDFRef={pdfRef}
						exportGridAsExcelRef={excelRef}
						apiMethod={getPurchaseStaticsApi}
						pageable={false}
						showSelectedFilters={false}
						className={"purchaseStatistic-group-grid"}
						groupable={{ footer: "visible", enabled: false }}
						onFilteredDataChange={setGridData}
						itemAboveHeight={20}
						excelProps={{
							filterable: true,
							fileName: `${t("PurchaseStatistic")}_${new Date().toISOString()}.xlsx`,
						}}
						group={[
							{
								field: "group1",
								aggregates: [
									{ field: "netLiveWeightKg", aggregate: "sum" },
									{ field: "amount", aggregate: "sum" },
								],
							},
							{
								field: "group2",
								aggregates: [
									{ field: "netLiveWeightKg", aggregate: "sum" },
									{ field: "amount", aggregate: "sum" },
								],
							},
						]}
					/>
				)}
			</div> */}
			{tab === Tabs.PurchaseStatisticDetails ? (
				<PurchaseStatisticsDetails
					filterOptions={filterOptions}
					setFilterOptions={setFilterOptions}
					pageSize={pageSize}
				/>
			) : (
				<PurchaseStatisticTotal
					filterOptions={filterOptions}
					setFilterOptions={setFilterOptions}
					pageSize={pageSize}
				/>
			)}
		</div>
	);
};

export default PurchaseStatisticPage;
